import {OperatingSystem} from 'common/api/api'
import {
    DictionarySelector,
    DictionarySelectorProps,
    enumToLabelValue
} from './DictionarySelector'
import {Flex, Input, Modal} from 'antd'
import {FC, useState} from 'react'
import NameEnum = OperatingSystem.NameEnum

const MOBILE_OS = [OperatingSystem.NameEnum.IOS, OperatingSystem.NameEnum.Android, OperatingSystem.NameEnum.IOSIPad, OperatingSystem.NameEnum.IOSIPhone].map(name => String(name))

export const OsSelector: FC<DictionarySelectorProps> = (props) => {
    const [visible, setVisible] = useState(false)
    const [elemTmp, setElemTmp] = useState<any>(undefined)
    const [min, setMin] = useState<string | undefined>(undefined)
    const [max, setMax] = useState<string | undefined>(undefined)

    const onChangeInternal = (value: Array<any>) => {
        let waitVersion = false
        const oldValue = props.value || []
        if (value.length == oldValue.length + 1) { // it is addition of the element
            const propsValueNames: Array<string> = oldValue.map(os => String(os.name))
            const elem = value.filter(el => !propsValueNames.includes(el))[0]
            if (MOBILE_OS.includes(elem)) {
                props.onChange && props.onChange(props.value) // need for the closing of the select list

                setElemTmp(elem)
                setMin(undefined)
                setMax(undefined)
                setVisible(true)
                waitVersion = true
            }
        }

        if (!waitVersion) {
            props.onChange && props.onChange(convertToOperatingSystems(value))
        }
    }

    const convertToOperatingSystems = (value: Array<any>) => {
        return value.map(os => {
            const operatingSystem = findOperatingSystem(props.value, os)
            return operatingSystem || {name: os, versionMin: undefined, versionMax: undefined} as OperatingSystem
        })
    }

    const findOperatingSystem = (values: any, name: string) => {
        return values && values.find(os => String(os.name) === name)
    }

    const callOnChangeWithNewOperatingSystem = (os: OperatingSystem) => {
        const operatingSystems = props.value ? props.value : []
        operatingSystems.push(os)
        props.onChange && props.onChange(operatingSystems)
    }

    const renderLabel = ({label}) => {
        const os: OperatingSystem = findOperatingSystem(props.value, label)
        if (os && (os.versionMax || os.versionMin)) {
            if (os.versionMin && os.versionMax) {
                return `${label} (${os.versionMin}-${os.versionMax})`
            } else if (os.versionMin) {
                return `${label} (\u2265${os.versionMin})`
            } else {
                return `${label} (\u2264${os.versionMax})`
            }
        } else {
            return label
        }
    }

    return <>
        <DictionarySelector {...props}
                            cacheKey="os" loader={() => enumToLabelValue(NameEnum)}
                            mode="multiple"
                            value={props.value?.map(os => String(os.name))}
                            onChange={onChangeInternal}
                            labelRender={renderLabel}
        />
        <Modal centered title={`${elemTmp} version`} open={visible} width={400}
               onCancel={() => {
                   setVisible(false)
                   callOnChangeWithNewOperatingSystem({
                       name: elemTmp,
                       versionMin: undefined,
                       versionMax: undefined
                   } as OperatingSystem)
               }}
               onOk={() => {
                   setVisible(false)
                   callOnChangeWithNewOperatingSystem({
                       name: elemTmp,
                       versionMin: min,
                       versionMax: max
                   } as OperatingSystem)
               }}
        ><span>Version targeting available for mobile traffic only</span>
            <Flex gap={8} style={{marginTop: 20}}>
                <span style={{display: "inline-flex", alignItems: "center"}}>Version</span>
                <Input value={min} placeholder="Min" onChange={e => setMin(e.target.value)}/>
                <Input value={max} placeholder="Max" onChange={e => setMax(e.target.value)}/>
            </Flex>
        </Modal>
    </>
}